const enum ConferenceRoomType {
  twilio = 'twilio2',
}
export default ConferenceRoomType;
